module.exports = __webpack_public_path__ + "img/720.4a4a383e.svg";